export default {
  oma: {
    fromDate: "Tarehe ya Kuanzia",
    toDate: "Tarehe ya Mwisho",
    selectDate: "Chagua Tarehe",
    cancel: "GHAIRI",
    avocadoTreesList: "Orodha ya Miti ya Avocado",
    addTreesManually: "Ongeza Mahali ya Jiogeolojia ya Mti kwa Mkono",
    confirmationTitle: "Uthibitisho",
    confirmationMessage: "Mti wa Avocado umeongezwa/haririwa kwa mafanikio",
    addTreesBulk: "Wezesha miti kwa wingi",
    addNewFarm: "Chagua Shamba",
    selectFarm: "Chagua Shamba",
    selectZone: "Chagua Eneo",
    treeId: "Kitambulisho cha Mti",
    treeName: "Jina la Mti",
    zoneId: "Kitambulisho cha Eneo",
    latitude: "Latitudo",
    longitude: "Longitudo",
    altitude: "Kimo",
    timestamp: "Muda",
    avocadoTrees: "Miti ya Avocado",

    //land suitability
    landSuitibility: "Ufaa wa Ardhi",
    landSuitibilityReport: "Ripoti ya Ufaa wa Ardhi",
    generateNewReport: "Jenga Ripoti Mpya",
    operatorName: "Jina la Mwendeshaji",
    issueDate: "Tarehe ya Kutolewa",
    chooseYourLocation: "Chagua Mahali Pako",
    getLandEvaluation: "Pata Tathmini ya Ardhi",
    downloadPdfReport: "Pakua Ripoti ya PDF",
    pleaseEnterCoordinateText:
      "Tafadhali ingiza viwango (latitudo na longitudo) vya eneo la shamba ili uone alama.",
    noRecordAvailable: "Hakuna Rekodi Zinazopatikana.",
    overallScoreForLand: "Alama Jumla ya Ufaa wa Ardhi",
    landEvaluation: "Tathmini ya Ardhi",
    unsuitable: "Haijafaa",
    marginally: "Kwa Kiasi Kidogo",
    suitable: "Inafaa",
    moderately: "Kwa Kiasi",
    highly: "Kwa Kiasi Kikubwa",
    back: "Rudi",
    search: "Tafuta",
    showResults: "Onyesha Matokeo",
    //weather analysis
    weatherAnalysisReport: "Ripoti ya Uchambuzi wa Hali ya Hewa",
    weatherAnalysis: "Uchambuzi wa Hali ya Hewa",
    getWeatherAnalysis: "Pata Uchambuzi wa Hali ya Hewa",
    weatherReport: "Ripoti ya Hali ya Hewa",
    filterByDate: "Chuja kwa Tarehe",
    insertCoordinateText:
      "Ingiza viwango vya latitudo na longitudo ya shamba (au mti) hapo juu au tumia ramani hapa chini kuonyesha eneo la shamba (au mti).",
    addTreeGeolocation: "Ongeza Mahali ya Mti",
    editTreeGeolocation: "Hariri Mahali ya Mti",
    plantationDate: "Tarehe ya Upandaji",
    notes: "Maelezo",
    uploadTreeImages: "Pakia Picha za Mti",
    valueAtTheCoordinatesOfInterest: "Thamani kwenye Mahali pa Kuvutiwa",
    "Slope (%)": "Mwinuko (%)",
    "Soil texture (USDA class)": "Muundo wa Udongo (Darasa la USDA)",
    "Coarse fragments (vol%)": "Vipande Vikali (asilimia%)",
    Land: "Ardhi",
    "Artificial surfaces (type)": "Nyuso Bandia (aina)",
    "Proximity to Type 1 and 2 Roads (meters)":
      "Ukaribu na Barabara za Aina 1 na 2 (mita)",
    "Soil Chemical Properties": "Mali ya Kemikali ya Udongo",
    "Soil Physical Properties": "Mali za Kimwili za Udongo",
    "Soil organic carbon (%)": "Karboni ya Kikaboni ya Udongo (%)",
    "Soil pH": "Asidi ya Udongo",
    "Soil salinity (ECe))": "Chumvi ya Udongo (ECe)",
    "Mean annual temperature (°C)": "Joto la wastani la kila mwaka (°C)",
    Weather: "Hali ya Hewa",
    "Mean minimum temperature of coldest month (°C)":
      "Joto la chini la kila mwezi wa baridi (°C)",
    "Mean annual precipitation (mm)": "Mvua ya wastani ya kila mwaka (mm)",
    avocadoDetailNoUpdates: "Hakuna Mabadiliko",
    avocadoTreeDetail: "Maelezo ya Mti",
    avocadoTreeDetailHeader: "Maelezo ya Mti wa Avocado",
    avocadoTreeUpdates: "Mabadiliko ya Mti wa Avocado",
    avocadoAddImages: "Ongeza Picha Mpya",
    addNewTreeImage: "Ongeza Picha Mpya ya Mti",
    selectCountry: "Chagua Nchi",
    allRegions: "Mikoa Yote",
    avocadoDetailCard: {
      clientTreeId: "Kitambulisho cha Mti",
      treeName: "Jina la Mti",
      latitude: "Latitudo",
      longitude: "Longitudo",
      altitude: "Kimo",
      zoneId: "Kitambulisho cha Eneo",
      createdAt: "Tarehe na Muda",
      updatedAt: "Imeboreshwa mwisho",
    },
    importCSVFormat: "Chapisha CSV",
    importGeoJsonFormat: "Chapisha GeoJSON",
    importShapeFilesFormat: "Chapisha Format za Kielelezo",
    importXLSFormat: "Chapisha Format ya XLS",
    importGeobufFormat: "Chapisha Geobuf Format",
    importGeoPackageFormat: "Chapisha GeoPackage Format",
    topoJsonFormat: "TopoJSON Format",

    avocadoTreeDetailsTableHeader: {
      updatedOn: "Imesasishwa Tarehe",
      updatedBy: "Imesasishwa Na",
      notes: "Maelezo",
      noOfImages: "Idadi ya Picha",
      actions: "Vitendo",
    },
    avocadoTreeView: "Mtazamo wa Mti",
    avocadoFarmView: "Mtazamo wa Shamba",
    avocadoTreeDetailPopupTitle: "Angalia Maelezo ya Mti",
    dateOfInterest: "Tarehe ya Kuvutiwa",
    maximumCloudCoverage: "Upeo wa Mawingu",

    import: "Ingiza",
    history: "Historia",
    downloandimport: "Pakua na Ingiza",
    importantNote: "Taarifa Muimu",
    downloadXlsFormat: "Pakua Muundo wa XLS",
    downloadCSVFormat: "Pakua Umbizo la CSV",
    downloadGeoJSONFormat: "Pakua Muundo wa GeoJSON",
    downloadTopoJSONFormat: "Pakua Muundo wa TopoJSON",
    downloadGeoPackageFormat: "Pakua Muundo wa GeoPackage",
    downloadGeobufFormat: "Pakua Muundo wa Geobuf",

    selectXLSFile: "Chagua Faili ya XLS",
    selectCSVFile: "Chagua Faili ya CSV",
    OrDragDrop: "au vuta na uwache hapa",
    importTrees: "Ingiza Miti",
    importantNoteDetail:
      "Taarifa Muimu: Tafadhali tumia templeti zilizotolewa hapo juu kwa uingizaji mkubwa. Miundo mingine itasababisha kushindwa.",

    fileName: "Jina la Faili",
    importedOn: "Imeingizwa Siku",
    status: "Hali",
    actions: "Vitendo",
    action: "Kitendo",
    download: "Pakua",
    removeFile: "Ondoa Faili",
    importedTrees: "Miti Iliyoagizwa Nje",
    geolocation: "Uwekaji kijiografia",
    "Export CSV Format": "Nakili CSV Muundo",
    "Export XLSX Format": "Nakili XLSX Muundo",
    "Export PDF Format": "Nakili PDF Muundo",
  },
};
